import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import './GroupPreviewSection.scss';

interface ExistingGroup {
  selection_group_id: number;
  selection_group_name: string;
  selection_group_description?: string;
  local_id: number;
  is_new: boolean;
  items_contained: Array<{
    item_id: number;
    item_name: string;
    label: string;
    is_new: boolean;
    price_modifier: number;
    delivery_price_modifier: number;
    online_price_modifier: number;
    desk_price_modifier: number;
    min_selections: number;
    max_selections: number;
  }>;
  total_items_contained: number;
  has_price_modifiers: boolean;
  has_descriptions: boolean;
  has_selection_constraints: boolean;
  configuration_complexity: {
    has_multiple_contained_items: boolean;
    has_complex_pricing: boolean;
    has_selection_rules: boolean;
  };
}

interface GroupPreviewSectionProps {
  selectedGroup: ExistingGroup;
}

const GroupPreviewSection: React.FC<GroupPreviewSectionProps> = ({
  selectedGroup
}) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };

  return (
    <div className="group-preview-section-clean">
      <h6 className="preview-title-clean">Vista Previa del Grupo</h6>
      
      <Card className="preview-card-clean">
        <Card.Header className="preview-header-clean">
          <div className="group-info-header-clean">
            <h6 className="group-name-preview-clean">{selectedGroup.selection_group_name}</h6>
            {selectedGroup.selection_group_description && (
              <p className="group-description-preview-clean">
                {selectedGroup.selection_group_description}
              </p>
            )}
          </div>
          <Badge bg="primary" className="items-count-badge-clean">
            {selectedGroup.total_items_contained} opciones
          </Badge>
        </Card.Header>
        
        <Card.Body className="preview-body-clean">
          <div className="items-table-container-clean">
            <Table responsive className="items-preview-table-clean">
              <thead>
                <tr>
                  <th>Opción</th>
                  <th>Restaurante</th>
                  <th>Delivery</th>
                  <th>Online</th>
                  <th>Mesa</th>
                </tr>
              </thead>
              <tbody>
                {selectedGroup.items_contained.map((item) => (
                  <tr key={item.item_id}>
                    <td className="item-name-cell-clean">
                      <span className="item-name-text-clean">{item.item_name}</span>
                    </td>
                    <td className="price-cell-clean">
                      {item.price_modifier !== 0 ? (
                        <span className={`price-modifier-clean ${item.price_modifier > 0 ? 'positive' : 'negative'}`}>
                          {item.price_modifier > 0 ? '+' : ''}{formatPrice(item.price_modifier)}
                        </span>
                      ) : (
                        <span className="no-modifier-clean">—</span>
                      )}
                    </td>
                    <td className="price-cell-clean">
                      {item.delivery_price_modifier !== 0 ? (
                        <span className={`price-modifier-clean ${item.delivery_price_modifier > 0 ? 'positive' : 'negative'}`}>
                          {item.delivery_price_modifier > 0 ? '+' : ''}{formatPrice(item.delivery_price_modifier)}
                        </span>
                      ) : (
                        <span className="no-modifier-clean">—</span>
                      )}
                    </td>
                    <td className="price-cell-clean">
                      {item.online_price_modifier !== 0 ? (
                        <span className={`price-modifier-clean ${item.online_price_modifier > 0 ? 'positive' : 'negative'}`}>
                          {item.online_price_modifier > 0 ? '+' : ''}{formatPrice(item.online_price_modifier)}
                        </span>
                      ) : (
                        <span className="no-modifier-clean">—</span>
                      )}
                    </td>
                    <td className="price-cell-clean">
                      {item.desk_price_modifier !== 0 ? (
                        <span className={`price-modifier-clean ${item.desk_price_modifier > 0 ? 'positive' : 'negative'}`}>
                          {item.desk_price_modifier > 0 ? '+' : ''}{formatPrice(item.desk_price_modifier)}
                        </span>
                      ) : (
                        <span className="no-modifier-clean">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GroupPreviewSection;
